export interface DefaultCustomerState {
  myCustomers: [];
  myCustomersLoading: boolean;
  bezorgmomenten: [];
  bezorgmomentenLoading: boolean;
}

export const defaultCustomerState: DefaultCustomerState = {
  myCustomers: [],
  myCustomersLoading: false,
  bezorgmomenten: [],
  bezorgmomentenLoading: false
};
